(function ($j) {
  'use strict';

    var $mediaGallery = $j('.media-gallery-content');

    if (!$.mpySlider) {
        return;
    }

  $mediaGallery.mpySlider({
    carouselAnimationStyle: 'scroll',		// Examples: 'scroll', fade', crossfade'
    carouselSlidesVisible: 1,				// How many slides are showing at once
    carouselSlidesVisible_SM: 2,			// How many slides are showing at once on bootstrap SM
    carouselSlidesVisible_MD: 3,			// How many slides are showing at once on bootstrap MD
    carouselSlidesVisible_LG: 4,			// How many slides are showing at once on bootstrap LG
    carouselSlidingOffset: 1,				// How many slides away to animate to
    carouselSlideDuration: 600000,			// How long to stay on each slide before animating
    carouselAnimationSpeed: 500			// Speed of animation between slides
  });

  $mediaGallery.find('.carousel-action-prev').bind('click touchstart', function () {
    $mediaGallery.find('.mpyCarousel').trigger('prev');
  });

  $mediaGallery.find('.carousel-action-next').bind('click touchstart', function () {
    $mediaGallery.find('.mpyCarousel').trigger('next');
  });
}(window.$j));
